import { useMemo } from 'react';
import { generatePath, RouteE } from 'src/constants/pages.constants';
import type { IUser } from '@tacans/shared-marketplace-layer';

export const useProfileLoginUrl = (user?: IUser) => useMemo(() => (
    generatePath(RouteE.PROFILE, { login: (user?.login || '').toLowerCase() })
), [user]);
